module.exports = __webpack_public_path__ + "img/finance.f2ece261.png";